import * as ACTIONS from "../actions";

import Api, { LIVE } from "../../services";
import com from "./CommonFunction";
var CryptoJS = require("crypto-js");

// var SiteKey = process.env.NODE_ENV == "development" ? "6LfNaswZAAAAAEXPQDiJVVKjP0v7B6PBtBlkWC9N" :
//   "6Ld9ofcZAAAAAEmRD3bxw3Ee9lKIwQOk0EA0Ix3p";

const state = {
  isloading: false,
  error: null,
  token: null,
  isAuthenticated: false,
  name: null,
  UserId: null,
  RoleId: null,
  Bank: null,
  Branch: null,
  hideBranch: null,
  deptId: null,
  Roles: {
    Admin: 1,
    ITadmin: 2,
    CHECKER: 2,
    MAKER: 3,
  },
  BankUserRoles: {
    Approver: 1,
    Requester: 2,
  },
  //Key: "6Lc1acgZAAAAADA-weIt6SNnvpfRTFOdnxydr5r-", //'Live
  Key: LIVE
    ? "6LdqimMcAAAAADwSTihQxFCmcwMAiZPUq8BjegHJ"
    : "6LfNaswZAAAAAEXPQDiJVVKjP0v7B6PBtBlkWC9N", //UAT KEY
};

const getters = {
  loading: (state) => state.isloading,
  error: (state) => state.error,
  authencticate: (state) => state.isAuthenticated,
  Bank: (state) => state.Bank,
  RoleId: (state) => state.RoleId,
  name: (state) => state.name,
  Branch: (state) => state.Branch,
  TOKEN: (state) => state.token,
  Roles: (state) => state.Roles,
  UserId: (state) => state.UserId,
  BankUserRoles: (state) => state.BankUserRoles,
  deptId: (state) => state.deptId,
  GetSiteKey: (state) => state.Key,
};

const actions = {
  [ACTIONS.LOGIN_REQUEST]: (context, user) => {
    return new Promise((resolve, reject) => {
      //form.append('Username','noor');
      //var { commit } = context;
      var params = new URLSearchParams();
      var _username = com.Encrypt(user.Username);
      var _password = com.Encrypt(user.Password);
      params.append("Username", _username);
      params.append("Password", _password);
      params.append("Captcha", user.Captcha);
      context.commit(ACTIONS.AUTH_LOGIN_PENDING);
      Api.post("/Authenticate/Login", params)
        .then((res) => {
          var { data } = res;

          if (data && data.StatusCode == 200) {
            //context.commit(ACTIONS.AUTH_LOGIN_SUCCESS);
            var role = DecryptRoleAndDepartment.Decrypt(
              data.ResponseData.RoleId,
            );
            role = role == null || role == "" ? 0 : parseInt(role);
            data.ResponseData.RoleId = role;
            var dept = DecryptRoleAndDepartment.Decrypt(
              data.ResponseData.deptId,
            );
            dept = dept == null || dept == "" ? 0 : parseInt(dept);
            data.ResponseData.deptId = dept;
            HandleCookie.SetCookie(data);
            //   commit(ACTIONS.AUTH_LOGIN_SUCCESS, {
            //     accessToken: data.ResponseData.token,
            //     name: data.ResponseData.name,
            //     RoleId: data.ResponseData.RoleId,
            //     UserId: data.ResponseData.user,
            //     deptId: data.ResponseData.deptId
            //   });
          } else if (data && data.StatusCode == 211) {
            context.commit(ACTIONS.AUTH_LOGIN_ERROR);
            return resolve(res);
          } else {
            //  context, res, SuccessAction, ErrorAction, (saveData = false);
            commit.success(
              context,
              res,
              ACTIONS.AUTH_LOGIN_SUCCESS,
              ACTIONS.AUTH_LOGIN_ERROR,
              false,
            );
            // commit(ACTIONS.AUTH_LOGIN_ERROR);
          }
          return resolve(res);
        })
        .catch((err) => {
          context.commit(ACTIONS.AUTH_LOGIN_ERROR);
          return reject(err);
        });
      // commit(ACTIONS.AUTH_LOGIN_SUCCESS)
    });
  },
  [ACTIONS.LOGIN_TOKEN_SAVE]: (context, data) => {
    return new Promise((resolve, reject) => {
      var params = new URLSearchParams();
      params.append("Client_ID", data.ClientId);
      params.append("UKey", data.UKey);
      params.append("Token", data.UToken);
      params.append("Salt_Token", data.SaltToken);
      context.commit(ACTIONS.AUTH_LOGIN_PENDING);
      Api.post("/Authenticate/SaveToken", params)
        .then((res) => {
          var { data } = res;
          if (data && data.StatusCode == 200) {
            context.commit(ACTIONS.AUTH_LOGIN_PENDING_CANCEL);
          }
        })
        .catch((err) => {
          context.commit(ACTIONS.AUTH_LOGIN_ERROR);
          return reject(err);
        });
    });
  },
  [ACTIONS.LOGIN_TOKEN_REQUEST]: (context, Salt_Token) => {
    return new Promise((resolve, reject) => {
      var params = new URLSearchParams();
      params.append("salttoken", Salt_Token);
      setTimeout(() => {
        context.commit(ACTIONS.AUTH_LOGIN_PENDING);
        Api.post("authenticate/GetTokenKey?" + params)
          .then((res) => {
            context.commit(ACTIONS.AUTH_LOGIN_PENDING_CANCEL);
            return resolve(res);
          })
          .catch((err) => {
            context.commit(ACTIONS.AUTH_LOGIN_ERROR);
            return reject(err);
          });
      }, 1000);
    });
  },
  [ACTIONS.LOAD_REQUEST]: ({
    // load cookies to  store
    commit,
  }) => {
    var key = "univ_id=",
      accessToken = "uid=",
      name = "un=",
      //Bank = "u_bid=",
      RoleId = "r0_id=",
      UserId = "_C_VD=",
      deptId = "_CVX_WR=",
      // Branch = "BR=",
      //  hideBranch = "HB=",
      _key = "",
      _token = "",
      _userId = "",
      _name = "",
      // _bank = "",
      _roleid = "",
      _deptId = "";
    //  _branch = "",
    // _hidebranch = "";
    var decodedCookie = decodeURIComponent(document.cookie);

    var ca = decodedCookie.split(";");
    if (ca) {
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        if (c) {
          c = c.toString().trim();
          if (c.indexOf(key) == 0) {
            _key = c.substring(key.length, c.length);
            continue;
          }
          if (c.indexOf(accessToken) == 0) {
            _token = c.substring(accessToken.length, c.length);
            continue;
          }
          if (c.indexOf(name) == 0) {
            _name = c.substring(name.length, c.length);
            continue;
          }
          if (c.indexOf(deptId) == 0) {
            _deptId = c.substring(deptId.length, c.length);
            continue;
          }

          // if (c.indexOf(Bank) == 0) {
          //   _bank = c.substring(Bank.length, c.length);
          //   continue;
          // }
          if (c.indexOf(RoleId) == 0) {
            _roleid = c.substring(RoleId.length, c.length);
            continue;
          }
          if (c.indexOf(UserId) == 0) {
            _userId = c.substring(UserId.length, c.length);
            continue;
          }
          // if (c.indexOf(Branch) == 0) {
          //   _branch = c.substring(Branch.length, c.length);
          //   continue;
          // }
          // if (c.indexOf(hideBranch) == 0) {
          //   _hidebranch = c.substring(hideBranch.length, c.length);
          //   continue;
          // }
        }
      }
      if (_key && _key != "") {
        var data = {
          d_token: CryptoJS.AES.decrypt(_token, _key),
          d_roleid: CryptoJS.AES.decrypt(_roleid, _key),
          d_name: CryptoJS.AES.decrypt(_name, _key),
          d_userId: CryptoJS.AES.decrypt(_userId, _key),
          d_deptId: CryptoJS.AES.decrypt(_deptId, _key),
          // d_branch: CryptoJS.AES.decrypt(_branch, _key),
          // d_hidebranch: CryptoJS.AES.decrypt(_hidebranch, _key),
          /// d_branch: CryptoJS.AES.decrypt(_branch, _key),
          // d_bank: CryptoJS.AES.decrypt(_bank, _key)
        };
        var res = document.cookie;
        var multiple = res.split(";");
        for (var i = 0; i < multiple.length; i++) {
          var key = multiple[i].split("=");
          if (key[0] == " univ_id") {
            document.cookie =
              key[0] + " =; expires = Thu, 01 Jan 1970 00:00:00 UTC";
            break;
          }
        }
        commit(ACTIONS.LOAD_REQUEST_COMMIT, data);
      }
      // else {
      //   var res = document.cookie;
      //   var multiple = res.split(";");
      //   for (var i = 0; i < multiple.length; i++) {
      //     var key = multiple[i].split("=");
      //     document.cookie =
      //       key[0] + " =; expires = Thu, 01 Jan 1970 00:00:00 UTC";
      //   }
      // }
    }
  },
  [ACTIONS.LOGOUT_REQUEST]: (context) => {
    context.commit(ACTIONS.LOGOUT_REQUEST);
    var params = new URLSearchParams();
    params.append("token", context.state.token);

    Api.post("authenticate/logout" + "?token=" + context.state.token, {
      headers: {
        //"Content-Type": "application/x-www-form-urlencoded",
        token: context.state.token,
      },
    })
      .then((res) => {})
      .catch((err) => {});
    var res = document.cookie;
    var multiple = res.split(";");
    for (var i = 0; i < multiple.length; i++) {
      var key = multiple[i].split("=");
      document.cookie = key[0] + " =; expires = Thu, 01 Jan 1970 00:00:00 UTC";
    }
  },

  [ACTIONS.FORGOT_PASSWORD]: (context, query) => {
    context.commit(ACTIONS.FORGOT_PASSWORD_PENDING);
    return new Promise((resolve, reject) => {
      Api.post("authenticate/forgotpassword", query)
        .then((res) => {
          commit.success(
            context,
            res,
            ACTIONS.FORGOT_PASSWORD_SUCCESS,
            ACTIONS.FORGOT_PASSWORD_ERROR,
            true,
          );
          return resolve(res);
        })
        .catch((err) => {
          commit.Error(context, err, ACTIONS.FORGOT_PASSWORD_ERROR);
          return reject(err);
        });
    });
  },
};

const mutations = {
  [ACTIONS.AUTH_LOGIN_PENDING]: (state) => {
    state.isloading = true;
  },
  [ACTIONS.AUTH_LOGIN_PENDING_CANCEL]: (state) => {
    state.isloading = false;
  },
  [ACTIONS.AUTH_LOGIN_SUCCESS]: (state, data) => {
    state.isloading = false;
    state.isAuthenticated = true;
    state.token = data.accessToken.toString();
    state.RoleId = data.RoleId;
    state.UserId = data.UserId;
    state.deptId = data.deptId;
    // (state.Bank = data.Bank),
    // (state.Branch = data.Branch),
    // (state.hideBranch = data.hideBranch),
    state.name = data.name;
  },
  [ACTIONS.LOAD_REQUEST_COMMIT]: (state, data) => {
    state.token = data.d_token.toString(CryptoJS.enc.Utf8);
    state.RoleId = data.d_roleid.toString(CryptoJS.enc.Utf8);
    //(state.Bank = JSON.parse(data.d_bank.toString(CryptoJS.enc.Utf8))),
    // (state.Branch = data.d_branch.toString(CryptoJS.enc.Utf8)),
    // (state.hideBranch = data.d_hidebranch.toString(CryptoJS.enc.Utf8)),
    state.name = data.d_name.toString(CryptoJS.enc.Utf8);
    state.UserId = data.d_userId.toString(CryptoJS.enc.Utf8);
    state.deptId = data.d_deptId.toString(CryptoJS.enc.Utf8);
    state.isAuthenticated = true;
  },
  [ACTIONS.AUTH_LOGIN_ERROR]: (state, msg) => {
    state.isloading = false;
    state.isAuthenticated = false;
    state.error = msg == undefined ? null : msg;
  },
  [ACTIONS.LOGOUT_REQUEST]: (state) => {
    state.isAuthenticated = false;
    state.loading = false;
    state.isloading = false;
    state.error = null;
    state.authencticate = null;
    state.Bank = null;
    state.RoleId = null;
    state.name = null;
    state.Branch = null;
    state.TOKEN = null;
  },
  [ACTIONS.FORGOT_PASSWORD_PENDING]: (state) => {
    state.isloading = true;
    state.error = null;
  },
  [ACTIONS.FORGOT_PASSWORD_SUCCESS]: (state) => {
    state.isloading = false;
    state.error = null;
  },
  [ACTIONS.FORGOT_PASSWORD_ERROR]: (state, msg) => {
    state.isloading = false;
    state.error = msg;
  },
};

const LoginModule = {
  state,
  getters,
  actions,
  mutations,
};
export default LoginModule;

const commit = {
  success: function(
    context,
    res,
    SuccessAction,
    ErrorAction,
    saveData = false,
  ) {
    var { commit } = context;
    var { data } = res;
    if (data && data.StatusCode == 200) {
      if (saveData) {
        commit(SuccessAction, data.ResponseData);
      }
    } else if (
      data &&
      (data.StatusCode == 500 ||
        data.StatusCode == 403 ||
        data.StatusCode == 1 ||
        data.StatusCode == 406 ||
        data.StatusCode == 0)
    ) {
      commit(ErrorAction, data.StatusMessage);
    } else if (data && data.StatusCode == 450) {
      commit(ErrorAction, "Validation Failed");
    } else {
      commit(ErrorAction, "Unknown Error");
    }
  },
  Error: function(context, err, ActionName) {
    var { commit } = context;
    if (err.response) {
      commit(ActionName, "Error " + err.status);
    }
    if (err.request) {
      commit(ActionName, err.message);
    } else {
      // Something happened in setting up the request that triggered an Error

      commit(ActionName, "Error " + err.message);
    }
  },
};

const key = CryptoJS.enc.Utf8.parse("7061737323313233");
const iv = CryptoJS.enc.Utf8.parse("7061737323313233");
const DecryptRoleAndDepartment = {
  Encrypt: function(string) {
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(string), key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted;
  },
  Decrypt: function(string) {
    var decrypted = CryptoJS.AES.decrypt(string, key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  },
};

const HandleCookie = {
  SetCookie: function(data) {
    var key = "",
      possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var length = Math.floor(Math.random() * 100) + 60;
    for (var i = 0; i < length; i++) {
      key += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    var accessToken = CryptoJS.AES.encrypt(data.ResponseData.token, key);
    var name = CryptoJS.AES.encrypt(data.ResponseData.name, key);
    var RoleId = CryptoJS.AES.encrypt("" + data.ResponseData.RoleId, key);
    var UserId = CryptoJS.AES.encrypt("" + data.ResponseData.user, key);
    var deptId = CryptoJS.AES.encrypt("" + data.ResponseData.deptId, key);

    var d = new Date();
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000); // two hrs
    var expires = "expires=" + d.toGMTString();
    var s = process.env.NODE_ENV == "development" ? "" : "secure;";

    var captchacode = localStorage.getItem("_grecaptcha");
    var nav_info = window.navigator;
    var screen = window.screen;
    var clientId =
      captchacode +
      ";" +
      nav_info.userAgent +
      ";" +
      nav_info.platform +
      ";" +
      nav_info.deviceMemory +
      ";" +
      nav_info.hardwareConcurrency;
    clientId +=
      ";" + screen.height + ";" + screen.width + ";" + screen.pixelDepth;
    clientId += ";" + screen.availHeight + ";" + screen.availWidth;
    clientId = CryptoJS.AES.encrypt(clientId, key);

    document.cookie =
      "client_id=" +
      clientId +
      ";" +
      expires +
      ";path=/" +
      ";samesite=strict;" +
      (s == "" ? "" : s);
    document.cookie =
      "univ_id=" +
      key +
      ";" +
      expires +
      ";path=/" +
      ";samesite=strict;" +
      (s == "" ? "" : s);
    document.cookie =
      "uid=" +
      accessToken +
      ";" +
      expires +
      ";path=/" +
      ";samesite=strict;" +
      (s == "" ? "" : s);
    document.cookie =
      "un=" +
      name +
      ";" +
      expires +
      ";path=/" +
      ";samesite=strict;" +
      (s == "" ? "" : s);
    //document.cookie = "u_bid=" + Bank + ";" + expires + ";path=/";
    document.cookie =
      "r0_id=" +
      RoleId +
      ";" +
      expires +
      ";path=/" +
      ";samesite=strict;" +
      (s == "" ? "" : s);
    document.cookie =
      "_C_VD=" +
      UserId +
      ";" +
      expires +
      ";path=/" +
      ";samesite=strict;" +
      (s == "" ? "" : s);
    document.cookie =
      "_CVX_WR=" +
      deptId +
      ";" +
      expires +
      ";path=/" +
      ";samesite=strict;" +
      (s == "" ? "" : s);
  },
};
